<template>
  <div class="product-item">
    <ProductDetailsComponent class="force-mobile" v-show="product.align == 'left'" :product="product"></ProductDetailsComponent>
    <ProductImageComponent :product="product"></ProductImageComponent>
    <ProductDetailsComponent class="hide-mobile" v-show="product.align == 'right'" :product="product"></ProductDetailsComponent>
  </div>
</template>

<script>

import ProductDetailsComponent from './ProductDetailsComponent'
import ProductImageComponent from './ProductImageComponent'

export default {
  props: [ 'product' ],
  components: {
    ProductDetailsComponent: ProductDetailsComponent,
    ProductImageComponent: ProductImageComponent
  },
  mounted() {},
  computed: {},
  methods: {},
  watch: {}
}
</script>

<style scoped>
  .product-item {
    display: block;
    white-space: nowrap;
    text-align: center;
    width: 80%;
    margin: 24px auto;
    padding: 48px 0;
    border-radius: 2px;
  }

  @media only screen and (max-width: 800px) {
    .product-item {
      width: 100%;
      margin: 0px auto;
    }
  }

  @media only screen and (max-width: 650px) {
    .force-mobile {
      display: block !important;
    }
    .hide-mobile {
      display: none !important;
    }
  }


</style>



// WEBPACK FOOTER //
// SingleProductComponent.vue?86d3b2b4